import { jwtDecodeToken } from 'lib/auth';
import { Entitlements } from 'enums';
export default function hasTDA(bamSessionToken) {
    const res = jwtDecodeToken(bamSessionToken);
    if (res.decodeSuccess) {
        const { context: { subscriptions = [] } = {} } = res.jwtToken || {};
        const hasTDA = subscriptions.some(sub => sub.entitlements.some(val => val === Entitlements.ESPN_TDA));
        if (hasTDA) {
            return true;
        }
    }
    return false;
}


// WEBPACK FOOTER //
// ./app/lib/auth/hasTDA.js